export default "__VITE_ASSET__JMp5Htiz__"